// <!-- GRACE:MODULE_START name="ui_config" -->
export const ENVIRONMENTS = {
  development: {
    API_BASE_URL: 'http://localhost:8000',
  },
  production: {
    API_BASE_URL: 'https://tolmach.kb99.pro',
  },
  w5: {
    API_BASE_URL: 'http://192.168.54.1:8000', // Замените на реальный IP машины w5
  }
} as const;

// Определяем текущее окружение
const getCurrentEnvironment = (): keyof typeof ENVIRONMENTS => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  } else if (hostname.includes('w5')) {
    return 'w5';
  } else {
    return 'production';
  }
};

// <!-- GRACE:CONTRACT function="getCurrentEnvironment" -->
export const CURRENT_ENV = getCurrentEnvironment();
export const CURRENT_CONFIG = ENVIRONMENTS[CURRENT_ENV];

// <!-- GRACE:MODULE_END name="ui_config" -->
